import Vue from "vue";
import VueResource from "vue-resource";
import serves from "./serves";
Vue.use(VueResource);
const http = Vue.http;
// http.options.root = 'http://127.0.0.1:8000/api/';
// http://rhwebsistemasinteligente.com.br.mobemaodeobra.com.br/

http.options.root = 'https://rhwebsistemasinteligente.com.br.mobemaodeobra.com.br/public/api';
Object.keys(serves).map(serve =>{
    serves[serve] = Vue.resource('',{},serves[serve])
})
const setBearetoken = token => {
    http.headers.common['Authorization'] = `Bearer ${token}`
}
// console.log(http.headers);
export default serves
export{http,setBearetoken}
